import { Search } from "lucide-react";
import { useState } from "react";
import { Icon } from "../../../components/Icon";
import { Input } from "../../../components/Input";
import { Select } from "../../../components/Select";
import { Textarea } from "../../../components/Textarea";
import { Section } from "../DesignSystem";

const col: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-4)",
  maxWidth: 480,
};

const PasswordExample = () => {
  const [reveal, setReveal] = useState(false);
  return (
    <Input
      type={reveal ? "text" : "password"}
      placeholder="Password"
      defaultValue="hunter2"
      trailingAction={
        <button
          type="button"
          onClick={() => setReveal((v) => !v)}
          style={{
            background: "none",
            border: 0,
            color: "inherit",
            cursor: "pointer",
            font: "inherit",
          }}
        >
          {reveal ? "Hide" : "Show"}
        </button>
      }
    />
  );
};

export const InputsSection = () => (
  <Section label="06 · Components" title="Inputs">
    <div style={col}>
      <Input placeholder="faria@centralsquaremarket.com" />
      <Input
        placeholder="Search stores"
        leadingIcon={<Icon icon={Search} />}
        trailingAction={<kbd>⌘K</kbd>}
      />
      <PasswordExample />
      <Input placeholder="Address" invalid defaultValue="" />
      <Input placeholder="Disabled" disabled />
      <Textarea placeholder="Small plate restaurant, 36 covers, open 11:00–23:00..." />
      <Select aria-label="Timezone" defaultValue="America/New_York">
        <option value="America/New_York">America/New_York</option>
        <option value="Europe/Berlin">Europe/Berlin</option>
        <option value="UTC">UTC</option>
      </Select>
    </div>
  </Section>
);
